// src/services/auth.js
import { auth, db } from "./firebaseConfig"; // 1. Importa o 'db' do Firestore
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore"; // 2. Importa funções do Firestore

const googleProvider = new GoogleAuthProvider();

/**
 * Realiza o login com Google e sincroniza o usuário com o Firestore.
 * @returns {Promise<UserCredential>} Uma promessa que resolve com as credenciais do usuário.
 */
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    const userDocRef = doc(db, "users", user.uid);
    const userDocSnap = await getDoc(userDocRef);

    if (!userDocSnap.exists()) {
      await setDoc(userDocRef, {
        uid: user.uid,
        name: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        role: "pending",
        createdAt: serverTimestamp(),
      });
    }

    return result;
  } catch (error) {
    console.error("Erro no login com Google ou na sincronização:", error);
    throw error;
  }
};

/**
 * Realiza o logout do usuário.
 * @returns {Promise<void>} Uma promessa que resolve quando o logout é concluído.
 */
export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Erro ao fazer logout:", error);
    throw error;
  }
};
